


import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const TasksService = {};

TasksService.addTask = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/Tasks",
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

TasksService.getAllTasks = function () {
  return axiosPrivate({
    method: "get",
    url: "/Tasks",
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

TasksService.uploadTaskPhoto = function (data, id) {
  return axiosPrivate({
    method: "post",
    url: `/Tasks/uploadImage/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

TasksService.deleteTask = function (id) {
  return axiosPrivate({
    params: {
      id: id,
    },
    method: "delete",
    url: "/Tasks",
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default TasksService;